import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import ManagersContent from "./ManagersContent";
import ActivitiesContent from "./PendingActivitiesContent";
import AnalyticsContent from "./AnalyticsContent";
import ProfileContent from "./ProfileContent"; // Import ProfileContent

const AdminDashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [activeTab, setActiveTab] = useState(
        localStorage.getItem("activeTab") || "activities" // Default to "activities"
    );

    const { user, tokens, logout } = useContext(AuthContext);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleTabChange = (tab) => {
        if (activeTab === tab) {
            // Trigger reload if the same tab is clicked
            setActiveTab(""); // Temporarily unset activeTab
            setTimeout(() => setActiveTab(tab), 0); // Re-set the tab after unsetting
        } else {
            setActiveTab(tab);
        }
        localStorage.setItem("activeTab", tab); // Save the active tab to localStorage
    };

    const renderContent = () => {
        switch (activeTab) {
            case "managers":
                return <ManagersContent />;
            case "activities":
                return <ActivitiesContent />;
            case "analytics":
                return <AnalyticsContent />;
            case "profile":
                return <ProfileContent />;
            default:
                return <ActivitiesContent />; // Default content
        }
    };

    const handleLogout = async () => {
        try {
            await logout({
                accessToken: tokens.accessToken,
                refreshToken: tokens.refreshToken,
            });
            console.log("Logged out successfully");
        } catch (error) {
            console.error("Failed to logout:", error.message);
        }
    };

    return (
        <div className="flex h-screen overflow-hidden">
            {/* Sidebar */}
            <div
                className={`bg-dark text-white flex flex-col ${
                    isSidebarOpen ? "w-64" : "w-16"
                } transition-all duration-300`}
            >
                {/* Sidebar Header */}
                <div className="p-4 border-b border-gray-700 flex items-center justify-between">
                    <span className={`text-xl font-bold ${isSidebarOpen ? "block" : "hidden"}`}>
                        {isSidebarOpen ? `Welcome, ${user?.username || "Admin"}!` : ""}
                    </span>
                    <button
                        onClick={toggleSidebar}
                        className="text-gray-400 hover:text-white"
                    >
                        ☰
                    </button>
                </div>

                {/* Sidebar Links */}
                <nav className="p-4 flex flex-col space-y-4">
                    <button
                        onClick={() => handleTabChange("managers")}
                        className={`flex items-center space-x-2 hover:text-gray-400 ${
                            activeTab === "managers" ? "text-white font-bold" : ""
                        }`}
                    >
                        <i className="fas fa-user-tie"></i>
                        <span className={isSidebarOpen ? "block" : "hidden"}>Managers</span>
                    </button>
                    <button
                        onClick={() => handleTabChange("activities")}
                        className={`flex items-center space-x-2 hover:text-gray-400 ${
                            activeTab === "activities" ? "text-white font-bold" : ""
                        }`}
                    >
                        <i className="fas fa-tasks"></i>
                        <span className={isSidebarOpen ? "block" : "hidden"}>Activities</span>
                    </button>
                    <button
                        onClick={() => handleTabChange("analytics")}
                        className={`flex items-center space-x-2 hover:text-gray-400 ${
                            activeTab === "analytics" ? "text-white font-bold" : ""
                        }`}
                    >
                        <i className="fas fa-chart-line"></i>
                        <span className={isSidebarOpen ? "block" : "hidden"}>Analytics</span>
                    </button>
                    <button
                        onClick={() => handleTabChange("profile")}
                        className={`flex items-center space-x-2 hover:text-gray-400 ${
                            activeTab === "profile" ? "text-white font-bold" : ""
                        }`}
                    >
                        <i className="fas fa-user"></i>
                        <span className={isSidebarOpen ? "block" : "hidden"}>Profile</span>
                    </button>
                </nav>
            </div>

            {/* Main Content */}
            <div className="flex-1 flex flex-col bg-light overflow-auto">
                {/* Top Navbar */}
                <div className="bg-white shadow p-4 flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <span className="text-lg font-bold">Admin Dashboard</span>
                    </div>
                    <div className="flex items-center space-x-4">
                        <button
                            className="text-gray-600 hover:text-gray-900 flex items-center space-x-2"
                            onClick={handleLogout}
                        >
                            <i className="fas fa-sign-out-alt text-xl"></i>
                            <span>Logout</span>
                        </button>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="p-6">{renderContent()}</div>
            </div>
        </div>
    );
};

export default AdminDashboard;
